<template>
  <div id="app" class="km">
    <NaviContainer @open_component_request="handleOpenComponentRequest"
                   @setProductList="openproductspopup"
                   :username="username"
                   :shoppingcart="shoppingcart"
                   :loggedin="loggedIn"
                   :auswahlprodukte_sortedinto_oberkategorien="auswahlprodukte_sortedinto_oberkategorien"
                   :land="land"
                   :language="language"
                   :hatMusterService="hatMusterService"
                   @logout="logout"
                   ref="menuref"
    />

    <ProductListPopup/>
    <ProductFeaturesPopupWrapperMobile/>

    <section class="km__stage">
      <Module3DViewer/>
      <ModulTrikotWender @changeside="einmalwendenbitte" v-if="wendenButtonAnzeigen"/>
    </section>
    <ArtikelView v-if="artikelViewOpen" :translator="t" :store="new VueXArtikelStoreWrapper()"/>
    <section class="km__modules">
      <nav class="km__modules__navi">
        <ModuleTabsList/>
      </nav>
      <div class="km__modules__content">
        <ModuleDesign/>
        <ModuleColor/>
        <ModuleText/>
        <ModuleLogo/>
      </div>

    </section>
    <section class="km__cta--btn">
      <button class="km__button--standard save" type="button" @click="saveEntwurf">{{ t("konf_SaveEntwurf") }}</button>
      <button class="km__button--standard shoppingcart" type="button" @click="putIntoBasket">{{ t("konf_toBasket") }}
      </button>
    </section>
    <ModuleCockpitCall/>
    <Transition name="fade">
      <ModuleCockpit v-if="cockpitOpen"/>
    </Transition>
    <Transition name="ypercent-transition">
      <ModuleDrafts v-if="draftsOpen"/>
    </Transition>
    <Transition name="ypercent-transition">
      <ModulePreiseUndLieferzeitenPopup v-if="preiseUndLieferzeitenOpen"/>
    </Transition>
    <ModuleUserPopupContainer @logout="logout"/>
    <ModulePopupContainer/>
    <ModuleMessageToUser/>
    <ModuleOKOKCancelDialog/>
    <ShaderEditor v-if="shaderEditorOpen"/>
    <ModuleScreenBlocker/>
    <ModuleUserManagementWrapper/>
    <ModulExemplarlisteIframeWrapper :language="language" :land="land" :saveid="saveid" :isopen="exemplarListeOpen"
                                     :tobasket="entwurfIsInWarenkorb"/>
  </div>
</template>

<script lang="ts" setup>

import ModuleTabsList from "@km/components/tabs/ModuleTabsList.vue";
import ModuleDesign from "@km/components/design/ModuleDesign.vue";
import ModuleColor from "@km/components/color/ModuleColor.vue";
import ModuleText from "@km/components/text/ModuleText.vue";
import ModuleLogo from "@km/components/logo/ModuleLogo.vue";
import ModulePopupContainer from "@km/components/popups/PopupContainer.vue"
import ModuleCockpitCall from "@km/components/cockpit/ModuleCockpitCall.vue";
import Module3DViewer from "@km/components/3dviewer/Module3DViewer.vue";
import ModuleMessageToUser from "@km/components/popups/ModuleMessageToUser.vue";
import ModuleOKOKCancelDialog from "@km/components/popups/ModuleOKOKCancelDialog.vue";
import ModuleUserPopupContainer from "@km/components/user/ModuleUserPopupContainer.vue";
import ProductListPopup from "@km/components/productChange/ProductListPopup.vue";
import {InitMobile} from "@km/js/initMobile";
import {computed, defineAsyncComponent, onUnmounted, ref, Ref, watch} from "vue";
import {useStore} from "vuex";

import {GetParametersDecoded} from "@k/js/delme_globals";
import {loadLanguageAsync} from "@km/js/languageLoader";
import {useI18n} from "vue-i18n";
import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";
import {
  naviComplete_openRequestActionMap,
  Navigation_opencomponentHandler
} from "@km/js/navigation_opencomponentHandler";
import {OverlayNames} from "@km/store/frontendstate/TabOpenStatusStore";
import {ProduktAuswahlOberkategorie} from "@km/store/ProduktAuswahlStore";
import {LoginLogoutEventListener} from "@km/js/loginLogoutEventListener";
import ModuleScreenBlocker from "@km/components/ModuleScreenBlocker.vue";
import {CookieBannerhandler} from "@k/global/cookieconsent/cookieConsent";
import {LocalizerVue} from "@km/js/LocalizerVue";
import ModuleUserManagementWrapper from "@km/components/usermanagmentWrapper/ModuleUserManagementWrapper.vue";
import {InterframeCommunicator} from "@k/global/frameCommunicator";
import {CookieHandler} from "@k/global/cookieconsent/cookieHandler";
import ModulExemplarlisteIframeWrapper from "@km/components/ModulExemplarlisteIframeWrapper.vue";
import {ExemplarlisteWrapper, EXEMPLARYVIEW_PURPOSE} from "@k/global/ExemplarlisteWrapper";
import ModulTrikotWender from "@km/components/3dviewer/ModulTrikotWender.vue";
import {Product, SelectedFeature} from "@k/js/product";
import globalsObject from "@k/js/globalsObject";
import {OpenWarenkorbController} from "@k/js/controllerModules/openWarenkorbController";
import ProductFeaturesPopupWrapperMobile from "@km/components/productChange/ProductFeaturesPopupWrapperMobile.vue";
import {initProduktWechselMobile} from "@km/components/productChange/produktwechselInit";
import {VueXArtikelStoreWrapper} from "@km/components/artikel/VueXArtikelStoreWrapper";
import {initELs} from "@km/js/initEventListeners";
import {exemplarlisteOpener, setExemplarlisteOpener} from "@km/js/exemplarListeOpener";
import {useProductInfoStore} from "@k/vue/store/ProductInfoStore";
import {rewriteKonfiVersionBeiBedarf} from "@k/global/globalUtils";

rewriteKonfiVersionBeiBedarf();


const ModuleCockpit = defineAsyncComponent(() => import("@km/components/cockpit/ModuleCockpit.vue"));
const ShaderEditor = defineAsyncComponent(() => import("@km/components/popups/debug/ShaderEditor.vue"));
const ModuleDrafts = defineAsyncComponent(() => import("@km/components/drafts/ModuleDrafts.vue"));
const ArtikelView = defineAsyncComponent(() => import("@km/components/artikel/ArtikelView.vue"));
const ModulePreiseUndLieferzeitenPopup = defineAsyncComponent(() => import("@km/components/cockpit/ModulePreiseUndLieferzeitenPopup.vue"));

const store = useStore();
initProduktWechselMobile();
setExemplarlisteOpener(new ExemplarlisteWrapper(
        store.getters["ModelStore/getLanguage"],
        () => store.commit("SET_OVERLAY_OPEN", OverlayNames.exemplarliste),
        () => store.commit("SET_OVERLAY_CLOSED", OverlayNames.exemplarliste),
        () => {
        }
    )
);
store.dispatch("loadGetParametersCached");
const i18n = useI18n();
LocalizerVue.setI18nInstance(i18n);
const eventListener = new EventListener();
onUnmounted(() => EventVerteiler.unsubscribe(eventListener));
new LoginLogoutEventListener(store);

watch(() => store.getters.getInfoFromGetParameters, (infoFromGetParameters: null | GetParametersDecoded) => {
  if (infoFromGetParameters === null) {
    return;
  }
  if (i18n.locale.value !== infoFromGetParameters.lang) {
    loadLanguageAsync(infoFromGetParameters.lang, i18n).then(() => CookieBannerhandler.init(i18n.t));
  } else {
    CookieBannerhandler.init(i18n.t);
  }
  const init = new InitMobile(infoFromGetParameters);
  watch(() => store.getters["ModelStore/getLanguage"], (newlang) => store.dispatch("laenderlistenStore/loadCountryList", newlang), {immediate: true});
  initELs(eventListener, store, i18n);
  init.run();
});
Navigation_opencomponentHandler.init(store, naviComplete_openRequestActionMap);
const menuref = ref(null) as Ref<null | { close: () => void }>
InterframeCommunicator.initWindowListener();
(window as any).EventVerteiler = EventVerteiler;
if (CookieHandler.getCookieValue(CookieHandler.SHADEREDITOR_COOKIENAME) === "1") {
  store.commit("debugStore/SHOW_SHADEREDITOR_BUTTON");
}


const t = s => i18n.t(s);
const logout = () => store.dispatch("logout");
const handleOpenComponentRequest = component => Navigation_opencomponentHandler.open_component(component);
const draftsOpen = computed(() => store.getters.draftsoverlayIsOpen);
const cockpitOpen = computed(() => store.getters.cockpitIsOpen);
const preiseUndLieferzeitenOpen = computed(() => store.getters.preiseUndLieferzeitenIsOpen);
const exemplarListeOpen = computed(() => store.getters.exemplarListeIsOpen);
const artikelViewOpen = computed(() => store.getters.artikelViewIsActive);
const shaderEditorOpen = computed(() => store.getters["debugStore/shaderEditorOpen"]);

// isDevelopement: () => import.meta.env.DEV,
const openPopup = popup => store.commit("SET_OVERLAY_OPEN", popup);
const openproductspopup = liste => {
  store.commit("SET_PRODUCTS_TO_DISPLAY_AT_PRODUCTCHANGE", liste);
  store.commit("SET_OVERLAY_OPEN", OverlayNames.produktliste);
  menuref.value?.close();
};
const saveEntwurf = () => {
  globalsObject.googleTracker.trackPageview("entwurfgespeichert.htm");
  globalsObject.loopTracker.trackToolBoxEvent("save_draft");
  globalsObject.actionController.saveEntwurf().then(() => {
  });
};
const putIntoBasket = () => {
  store.commit("SET_INBASKET_FLAG", true);
  globalsObject.actionController.saveEntwurf().then(
      () => exemplarlisteOpener.openExemplarlisteByPurpose(store.getters.getEntwurfsID, store.getters["ModelStore/getLieferland"], EXEMPLARYVIEW_PURPOSE.EDIT_PUT_IN_BASKET)
          .then(
              () => {
                OpenWarenkorbController.open(
                    {
                      kundenKonfi: store.getters["ModelStore/getKundenKonfi"],
                      sprache: store.getters["ModelStore/getSprache"],
                      land: store.getters["ModelStore/getLand"],
                      entwurfID: store.getters.getEntwurfsID,
                      webSportFuerProduktAuswahlInt: store.getters["ModelStore/getWebSportFuerProduktAuswahlInt"]
                    }
                );
              }
          )
  )
};
const username = computed(() => store.getters.getUsername);
const shoppingcart = computed(() => store.getters.getWarenkorbPos);
const loggedIn = computed(() => store.getters.isLoggedIn);
const auswahlprodukte_sortedinto_oberkategorien = computed(() => store.getters.getAuswahlProdukteSortedIntoOberkategorien as ProduktAuswahlOberkategorie[]);

const language = computed(() => store.getters["ModelStore/getLanguage"]);
const land = computed(() => store.getters["ModelStore/getLand"]);
const saveid = computed(() => store.getters.getEntwurfsID);
const entwurfIsInWarenkorb = computed(() => store.getters.getInBasket);
const einmalwendenbitte = () => EventVerteiler.broadcast("einmalWendenBitte");
const wendenButtonAnzeigen = computed(
    () => (store.getters["ModelStore/getCurrentOwayoProduct"] as Product | null)
        ?.selectedFeatures.find((sf: SelectedFeature) => sf.feature === "Wendbar") !== undefined);

const productInfoStore=useProductInfoStore();
watch(() => store.getters["ModelStore/getCurrentOwayoProduct"], (currentOwayoProduct: null | Product) => {
  productInfoStore.load(currentOwayoProduct?.productWebNormalized, currentOwayoProduct?.sportart, language, land);
});
const hatMusterService = computed(() => productInfoStore.get.hatMusterService);

</script>

<style lang="scss">
@use "scss/settings/config" as config;
@use "scss/settings/mixins.scss" as mixins;

@include mixins.fadeTransition;
@include mixins.ypercentTransition;
.btn-drafts {
  display: block;
  width: 160px;
  height: 40px;
  margin: 10px auto 0 auto;
}

.km__cta--btn {
  .km__button--standard {
    height: 40px;
    border: none;
    color: config.$color-white;
    font-weight: 600;

    &.save {
      background: config.$ow-black;

    }

    &.shoppingcart {
      background: config.$color-blue;
      border-left: 1px solid config.$color-white;
    }
  }

}
</style>
